import { CheckOutlined } from '@ant-design/icons';
import { InstagramIcon } from '@mm/icons';
import React from 'react';
import { ReactComponent as InstachampLogo } from './instachamp-logo.svg';
import { ReactComponent as FacebookIcon } from './facebook.svg';
import { ReactComponent as PhoneIcon } from './phone.svg';
import { ReactComponent as RuggedBackground } from './rugged-background-green.svg';
import styles from './PromoteInstachamp.module.css';
import classNames from 'classnames';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import { MOBILE_SMALL } from '../../../../editor/constants/screenSize';
import { useResolutionInfo } from '@mm/hooks';

export const PromoteInstachamp = () => {
  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_SMALL;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        We have the perfect fit for your business based on your web traffic!
      </div>

      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.header}>
            <div className={styles.heading}>
              Generate leads with Instagram & Facebook Messenger Autoresponders
            </div>
            <div className={styles.logo}>
              <InstachampLogo />
              by Customers.ai
            </div>
          </div>

          {isMobile && (
            <div className={styles.right}>
              <div className={styles.image}>
                <FacebookIcon
                  className={classNames(styles.channelIcon, styles.facebook)}
                />
                <InstagramIcon
                  className={classNames(styles.channelIcon, styles.instagram)}
                />
                <PhoneIcon />
              </div>
              <span className={styles.note}>
                When a user engages with you on Instagram or Facebook, start a
                conversation in DM
              </span>
            </div>
          )}

          <div className={styles.description}>
            <div className={styles.heading}>Key Use Cases:</div>
            <div className={styles.point}>
              <CheckOutlined className={styles.checkIcon} />
              Increasing Social Engagement
            </div>
            <div className={styles.point}>
              <CheckOutlined className={styles.checkIcon} />
              Social Media automation
            </div>
          </div>
        </div>

        {!isMobile && (
          <div className={styles.right}>
            <div className={styles.image}>
              <FacebookIcon
                className={classNames(styles.channelIcon, styles.facebook)}
              />
              <InstagramIcon
                className={classNames(styles.channelIcon, styles.instagram)}
              />
              <PhoneIcon />
            </div>
            <span className={styles.note}>
              When a user engages with you on Instagram or Facebook, start a
              conversation in DM
            </span>
          </div>
        )}
      </div>

      <div className={styles.actions}>
        <div className={styles.price}>
          <div className={styles.tag}>
            <RuggedBackground className={styles.ruggedBackground} />
            Free version
          </div>

          <span className={styles.point}>or</span>
          <div className={styles.heading}>
            $9 <span className={styles.point}>month for premium</span>
          </div>
        </div>

        <PrimaryButton
          className={styles.button}
          onClick={() => window.open(`${window.origin}/instachamp`, '_self')}
        >
          Choose InstaChamp
        </PrimaryButton>
      </div>
    </div>
  );
};
